@let isDisabled =
  selectedShifts.length > MAX_SELECTABLE_SHIFT_MODAL_ATTACHMENTS;
@let disabledButtonTranslation =
  isDisabled ? ('shift.page.add_attachments.button.disabled' | translate) : '';
<button
  nz-button
  nzType="default"
  class="w-100 fw-normal"
  (click)="addAttachments()"
  [disabled]="isDisabled || isOperationOnGoing"
  nz-tooltip
  [nzTooltipTitle]="disabledButtonTranslation"
>
  {{ 'general.add_attachments' | translate }}
</button>
